<h1>Welcome to TDQure</h1>
<div *ngIf="this.user && !this.user.isApproved">
  <h3>
    You are not yet approved to use TDQure, please contact an admin if you
    believe this is wrong.
  </h3>
</div>
